import { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { motion } from "framer-motion";
import { SearchBar } from "@/components/SearchBar";
import { LeaderboardSection, RecentReviewsSection, AddReviewSection } from "@/components/home";
import { useIsMobile } from "@/hooks/use-mobile";
import { DescriptionHeader } from "@/components/DescriptionHeader";
import { Button } from "@/components/ui/button";
import { Plane, BookOpen, Shield } from "lucide-react";
import { Helmet } from "react-helmet";
export const RootRouteHandler = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const authCheckTimeout = useRef<number | null>(null);
  const isMobile = useIsMobile();
  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        const {
          data
        } = await supabase.auth.getSession();
        if (!isMounted) return;
        if (authCheckTimeout.current) {
          clearTimeout(authCheckTimeout.current);
          authCheckTimeout.current = null;
        }
        setIsAuthenticated(!!data.session);
        if (data.session) {
          navigate('/dashboard', {
            replace: true
          });
        }
      } catch (error) {
        console.error("Auth check error:", error);
        if (isMounted) {
          setIsAuthenticated(false);
        }
      }
    };
    checkAuth();
    return () => {
      isMounted = false;
      if (authCheckTimeout.current) {
        clearTimeout(authCheckTimeout.current);
        authCheckTimeout.current = null;
      }
    };
  }, [navigate]);
  if (isAuthenticated === null) {
    return <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3
    }} className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </motion.div>;
  }
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.3
  }} className="min-h-screen bg-background px-0 py-0">
      <Helmet>
        <title>Film Hand Check Guide - Protect Your Film from X-Ray Damage at Airports</title>
        <meta name="description" content="The definitive film hand check guide for photographers. Find airports that properly handle film with manual security checks. Real photographer reviews, TSA guidelines, and hand check success rates." />
        <meta name="keywords" content="film hand check, airport film scanner, TSA film hand check, film photography travel, x-ray film damage, hand check film airport" />
        <link rel="canonical" href="https://safelightproject.com" />
      </Helmet>
      
      <main className={`container mx-auto ${isMobile ? 'px-2' : 'px-4'} py-4`}>
        <DescriptionHeader />
        <SearchBar />
        
        {isAuthenticated === false && <>
            
            
            <LeaderboardSection />
            <RecentReviewsSection />
            <AddReviewSection />
          </>}
      </main>
    </motion.div>;
};